import type { GpsPosition } from "./types";

export function directionLabel(direction: string | null | undefined): string {
  if (!direction) return "—";
  const d = direction.toLowerCase();
  if (d === "up") return "UP";
  if (d === "down") return "DN";
  return direction;
}

export function formatTime(value: string | null | undefined): string {
  if (!value) return "—";
  return value.length >= 8 ? value.slice(0, 8) : value;
}

export function formatDuration(minutes: number | null | undefined): string {
  if (minutes == null || !Number.isFinite(minutes)) return "—";
  const abs = Math.abs(minutes);
  const h = Math.floor(abs / 60);
  const m = Math.round(abs % 60);
  const sign = minutes < 0 ? "-" : "";
  if (h === 0) return `${sign}${m} min`;
  return `${sign}${h}h ${m}m`;
}

export function formatLate(minutes: number | null | undefined): string {
  if (minutes == null || !Number.isFinite(minutes)) return "—";
  if (minutes === 0) return "on time";
  if (minutes > 0) return `${minutes} min late`;
  return `${Math.abs(minutes)} min early`;
}

export function trainLabel(train: {
  train_number?: string | number | null;
  train_name?: string | null;
  direction?: string | null;
} | null | undefined): string {
  if (!train) return "Unknown train";
  const num = train.train_number != null ? String(train.train_number) : "";
  const name = train.train_name || "";
  const dir = directionLabel(train.direction);
  return [num, name, dir !== "—" ? dir : ""].filter(Boolean).join(" · ");
}

export function dash(value: string | number | null | undefined): string {
  if (value == null || value === "") return "—";
  return String(value);
}

export function matchesQuery(query: string, ...fields: Array<string | number | null | undefined>): boolean {
  const q = query.trim().toLowerCase();
  if (!q) return true;
  return fields.some((f) => f != null && String(f).toLowerCase().includes(q));
}

export function gpsSummary(pos: GpsPosition | null | undefined): string {
  if (!pos) return "no live position yet";
  return `${dash(pos.speed_kmh)} km/h · ${formatLate(pos.late_by_minutes)}`;
}

export function formatInstant(value: string | null | undefined): string {
  if (!value) return "—";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return value;
  return `${d.toLocaleString()} (${value})`;
}

export function formatCoord(value: number | null | undefined): string {
  if (typeof value !== "number" || !Number.isFinite(value)) return "—";
  return value.toFixed(6);
}
